/* global moment ajaxurl */

var Calendar = function (selector, events) {
    this.el = document.querySelector(selector);
    this.today = moment();
    this.current = moment().date(1);
    this.events = events;
    this.loadMonth();
};

Calendar.prototype.draw = function() {
    // Create Header
    this.drawHeader();
    // Draw Days
    this.drawDays(); 
    // Draw Month
    this.drawMonth();
};

Calendar.prototype.drawDays = function() {
    var self = this;
    if (!self.days) {
        // Create the header elements
        this.days = createElement('div', 'days');
        this.days.className = 'days clearfix';
        var d = moment().weekday(0);
        for ( var i = 0; i < 7; i++) {
            var day = createElement('span', 'day');
            day.innerHTML = d.format('ddd');
            d.add(1, 'days');
            this.days.appendChild(day);
        }

        this.el.appendChild(this.days);
    }
};
    
Calendar.prototype.drawHeader = function() {
    var self = this;
    if (!this.header) {
        // Create the header elements
        this.header = createElement('div', 'header');
        this.header.className = 'header';

        this.title = createElement('h3');

        var left = createElement('span', 'left fa fa-angle-left');
        var right = createElement('span', 'right fa fa-angle-right');
        right.addEventListener('click', function() { self.nextMonth(); });
        left.addEventListener('click', function() { self.prevMonth(); });

        // Append the Elements
        this.header.appendChild(left);
        this.header.appendChild(this.title); 
        this.header.appendChild(right);
        this.el.appendChild(this.header);
    }

    this.title.innerHTML = this.current.format('MMMM YYYY');
};

Calendar.prototype.drawMonth = function() {
    var self = this;

    this.events.forEach(function(ev) {
        ev.date = self.current.clone().date(Math.random() * (29 - 1) + 1);
    });

    if (this.month) {
        this.oldMonth = this.month;
        this.oldMonth.className = 'month out';
        this.oldMonth.addEventListener('webkitAnimationEnd', function() {
            self.oldMonth.parentNode.removeChild(self.oldMonth);
            self.month = createElement('div', 'month');
            self.backFill();
            self.currentMonth();
            self.fowardFill();
            self.el.appendChild(self.month);
            window.setTimeout(function() {
                self.month.className = 'month in';
            }, 16);
        });
    } else {
        this.month = createElement('div', 'month');
        this.el.appendChild(this.month);
        this.backFill();
        this.currentMonth();
        this.fowardFill();
        this.month.className = 'month new';
    }
};

Calendar.prototype.backFill = function() {
    var clone = this.current.clone();
    var dayOfWeek = clone.weekday();
    if (!dayOfWeek) { return; }

    clone.subtract('days', dayOfWeek + 1);

    for (var i = dayOfWeek; i > 0; i--) {
        this.drawDay(clone.add('days', 1));
    }
};

Calendar.prototype.fowardFill = function() {
    var clone = this.current.clone().add('months', 1).subtract('days', 1);
    var dayOfWeek = clone.weekday();

    if (dayOfWeek === 6) { return; }

    for (var i = dayOfWeek; i < 6; i++) {
      this.drawDay(clone.add('days', 1));
    }
};

Calendar.prototype.currentMonth = function() {
    var clone = this.current.clone();

    while (clone.month() === this.current.month()) {
      this.drawDay(clone);
      clone.add('days', 1);
    }
};

Calendar.prototype.getWeek = function(day) {
    if (!this.week || day.weekday() === 0) {
      this.week = createElement('div', 'week');
      this.month.appendChild(this.week);
    }
};

Calendar.prototype.drawDay = function(day) {
    var self = this;
    this.getWeek(day);

    // Outer Day
    var outer = createElement('div', this.getDayClass(day));
    $(outer).data('date', day.clone());
    
    outer.addEventListener('click', function() {
        self.openDay(this);
    });

    // Day Number
    var number = createElement('div', 'day-number', day.format('DD'));

//    this.drawEvents(day, outer);
    outer.appendChild(number);
//    outer.appendChild(events);
    this.week.appendChild(outer);
};

Calendar.prototype.drawEvents = function(day, element) {
    if (day.month() === this.current.month()) {
        var todaysEvents = this.events.reduce(function(memo, ev) {
            if (ev.date.isSame(day, 'day')) {
                memo.push(ev);
            }
            return memo;
        }, []);

        if ( todaysEvents.length ) {
            $(element).addClass('has-matches');
        }
    }
};

Calendar.prototype.getDayClass = function(day) {
    var classes = ['day'], me = this;
    if (day.month() !== this.current.month()) {
        classes.push('other');
    } else if ( me.today.isSame(day, 'day')) {
        classes.push('today');
    }
    if ( day.isBefore(me.today)) {
        classes.push('past');
    }
    if ( this.events.some((ev) => {
            return ev.data.isSame( day, 'day');
        }) ) {
        classes.push('has-matches');
    }

    return classes.join(' ');
};

Calendar.prototype.closeDetail = function() {
    var currentOpened = document.querySelector('.details');
    currentOpened.addEventListener('webkitAnimationEnd', function() {
        currentOpened.parentNode.removeChild(currentOpened);
    });
    currentOpened.addEventListener('oanimationend', function() {
        currentOpened.parentNode.removeChild(currentOpened);
    });
    currentOpened.addEventListener('msAnimationEnd', function() {
        currentOpened.parentNode.removeChild(currentOpened);
    });
    currentOpened.addEventListener('animationend', function() {
        currentOpened.parentNode.removeChild(currentOpened);
    });
    currentOpened.className = 'details out';
};

Calendar.prototype.openDay = function(el) {
    var details, arrow;
    var day = $(el).data('date');
    
    if ( $(el).hasClass('open') ) {
        $(el).removeClass('open');
        this.closeDetail();
        return;
    }
    
    $('.day.open').removeClass('open');
    $(el).addClass('open');
    
    var currentOpened = document.querySelector('.details');
    // Check to see if there is an open detais box on the current row
    if ( currentOpened && currentOpened.parentNode === el.parentNode) {
        details = currentOpened;
        arrow = document.querySelector('.arrow');
    } else {
        // Close the open events on differnt week row
        // currentOpened && currentOpened.parentNode.removeChild(currentOpened);
        if ( currentOpened ) {
            this.closeDetail();
        }
        
        // Create the Details Container
        details = createElement('div', 'details in');

        // Create the arrow
        arrow = createElement('div', 'arrow');

        // Create the event wrapper
        details.appendChild(arrow);
        el.parentNode.appendChild(details);
    }
    
    var todaysEvents = this.events.reduce(function(memo, ev) {
        if (ev.data.isSame(day, 'day')) {
            memo.push(ev);
        }
        return memo;
    }, []);

    this.renderEvents(todaysEvents, details);
  
    arrow.style.left = el.offsetLeft + ($(el).outerWidth() / 2) - 2 + 'px';
};

  Calendar.prototype.renderEvents = function(events, ele) {
    // Remove any events in the current details element
    var currentWrapper = ele.querySelector('.events');
    var wrapper = createElement('div', 'events in' + (currentWrapper ? ' new' : ''));

    events.forEach(function(ev) {
        var div = createElement('div', 'event');
        var span = createElement('span', '', ev.title + ( ev.score ? ' ' + ev.score : '' ));
        div.appendChild(span);
        wrapper.appendChild(div);
    });

    if (!events.length) {
        var div = createElement('div', 'event empty');
        var span = createElement('span', '', 'brak wydarzeń');

        div.appendChild(span);
        wrapper.appendChild(div);
    }

    if (currentWrapper) {
        currentWrapper.className = 'events out';
        currentWrapper.addEventListener('webkitAnimationEnd', function() {
          currentWrapper.parentNode.removeChild(currentWrapper);
          ele.appendChild(wrapper);
        });
        currentWrapper.addEventListener('oanimationend', function() {
          currentWrapper.parentNode.removeChild(currentWrapper);
          ele.appendChild(wrapper);
        });
        currentWrapper.addEventListener('msAnimationEnd', function() {
          currentWrapper.parentNode.removeChild(currentWrapper);
          ele.appendChild(wrapper);
        });
        currentWrapper.addEventListener('animationend', function() {
          currentWrapper.parentNode.removeChild(currentWrapper);
          ele.appendChild(wrapper);
        });
      } else {
        ele.appendChild(wrapper);
      }
  };


Calendar.prototype.nextMonth = function() {
    this.current.add('months', 1);
    this.next = true;
    this.loadMonth();
};

Calendar.prototype.prevMonth = function() {
    this.current.subtract('months', 1);
    this.next = false;
    this.loadMonth();
};

Calendar.prototype.loadMonth = function() {
    $('#twk-loading').addClass('show');
    $('#kalendarz-wynikow-content > .outer').removeClass('show');
    var first = this.current.clone().date(1), last = this.current.clone().endOf('month');
    var weekDay = first.weekday();
    first.subtract('days', weekDay);
    this.events = [];
    weekDay = last.weekday();

    last.add('days', 6 - weekDay);
    $.ajax({
        url: ajaxurl,
        type: 'GET',
        data: {
            action: 'getKalendarzMeczy',
            from: first.format('YYYY-MM-DD'),
            to: last.format('YYYY-MM-DD')
        },
        success: (data) => {
            if ( data.mecze !== undefined) {
                this.events = data.mecze;
                this.events.forEach(function(ev) {
                    ev.data = moment(ev.data, "YYYY-MM-DD");
                });
            }
            $('#twk-loading').removeClass('show');
            this.draw();
            $('#kalendarz-wynikow-content > .outer').addClass('show');
        }
    });
};

function createElement(tagName, className, innerText) {
    var ele = document.createElement(tagName);
    if (className) {
        ele.className = className;
    }
    if (innerText) {
        ele.innderText = ele.textContent = innerText;
    }
    return ele;
}

export default Calendar;




